import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "18",
  viewBox: "0 0 16 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  d: "M6.67647 4.83317C6.18916 4.83317 5.79412 5.20627 5.79412 5.6665C5.79412 6.12674 6.18916 6.49984 6.67647 6.49984L10.2059 6.49984C10.6932 6.49984 11.0882 6.12674 11.0882 5.6665C11.0882 5.20627 10.6932 4.83317 10.2059 4.83317L6.67647 4.83317Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.38235 3.1665C1.38235 1.78579 2.56748 0.666504 4.02941 0.666504H12.8529C14.3149 0.666504 15.5 1.78579 15.5 3.1665V14.8332C15.5 16.2139 14.3149 17.3332 12.8529 17.3332H4.02941C2.56748 17.3332 1.38235 16.2139 1.38235 14.8332V13.9998C0.895043 13.9998 0.5 13.6267 0.5 13.1665C0.5 12.7063 0.895043 12.3332 1.38235 12.3332V9.83317C0.895043 9.83317 0.5 9.46008 0.5 8.99984C0.5 8.5396 0.895043 8.1665 1.38235 8.1665V5.6665C0.895043 5.6665 0.5 5.29341 0.5 4.83317C0.5 4.37293 0.895043 3.99984 1.38235 3.99984V3.1665ZM3.14706 14.8332V13.9998C3.63437 13.9998 4.02941 13.6267 4.02941 13.1665C4.02941 12.7063 3.63437 12.3332 3.14706 12.3332V9.83317C3.63437 9.83317 4.02941 9.46008 4.02941 8.99984C4.02941 8.5396 3.63437 8.1665 3.14706 8.1665V5.6665C3.63437 5.6665 4.02941 5.29341 4.02941 4.83317C4.02941 4.37293 3.63437 3.99984 3.14706 3.99984V3.1665C3.14706 2.70627 3.5421 2.33317 4.02941 2.33317H12.8529C13.3403 2.33317 13.7353 2.70627 13.7353 3.1665V14.8332C13.7353 15.2934 13.3403 15.6665 12.8529 15.6665H4.02941C3.5421 15.6665 3.14706 15.2934 3.14706 14.8332Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3
  ]))
}